import { MapTo } from '@adobe/aem-react-editable-components';
import CardCompare, { CardCompareEditConfig } from './CardCompare';

export default MapTo('cob-corp-acquisition/components/creditonebank/card-compare')(CardCompare, CardCompareEditConfig);